import { api } from "..";

interface BanAgentPayload {
  agentId: number;
  reason?: string | null;
  expiresAt?: string | null;
}

interface UnbanAgentPayload {
  agentId: number;
}

export async function banAgent(
  payload: BanAgentPayload
): Promise<{ success: boolean }> {
  const { agentId, ...body } = payload;
  const res = await api.client.put(`/agents-new/${agentId}/ban`, body);
  return res.data;
}

export async function unbanAgent(
  payload: UnbanAgentPayload
): Promise<{ success: boolean }> {
  const res = await api.client.delete(`/agents-new/${payload.agentId}/ban`);
  return res.data;
}
